var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"uppladdade-filer-sammanstallning"}},[_c('h3',[_vm._v(_vm._s(_vm.$t("impulskontrollutredning.anmalan.myndighet.misstanke.kvittens.alla.utskrift.bilagor")))]),_c('ul',_vm._l((_vm.files),function(f){return _c('li',{key:f.id},[_vm._v(" "+_vm._s(f.file.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }